import React, {JSX} from "react";
import {Col, Row, Spinner} from "react-bootstrap";
import '../CommonCss/TableSmall.css'
import {SangerQCHistoryTableRow} from "./TanStackSangerQCHistoryTable";
import { API, RestOptions } from '../CommonFunc/amplifyApiCompat';
import { ConsoleLogger } from 'aws-amplify/utils';
import {sangerQcApiConsts} from "./Const";
import {
    ColumnDef,
} from "@tanstack/react-table";
import {SangerQCReportCSVTableRow, TanStackSangerQCReportTable} from "./TanStackSangerQCReportTable";

interface SangerQCReportCSVTableState {
    rows: SangerQCReportCSVTableRow[]
    loading: boolean
}

interface SangerQCReportTableProps {
    reportMetadata: SangerQCHistoryTableRow
    showErrorAlert(message: string): void
    refreshToken: string
}

const logger = new ConsoleLogger("SangerQCReportTable")

export class SangerQCReportTable extends React.Component<SangerQCReportTableProps, SangerQCReportCSVTableState> {
    constructor(props: any) {
        super(props);
        this.state = {
            rows: [],
            loading: true,
        }
    }

    componentDidMount() {
        this.getReportResult()
    }

    getReportResult() {
        this.setState({
            loading: true
        })
        let request: RestOptions = {
            headers: {},
            queryParams: {
                "uuid": this.props.reportMetadata.uuid,
            }
        }
        logger.debug("getReportResult request = ", request)
        API.get(sangerQcApiConsts.API_NAME, sangerQcApiConsts.Path.REPORT, request).then((response: { data: any }) => {
            logger.debug("Response from API - ", response)
            this.setState({
                rows: response.data,
                loading: false
            })
            this.setState({
                rows: response.data
            })
        }).catch((err: any) => {
            logger.error("SangerQCReportTable - getReportResult: Error from API", err)
            // Ignore and don't show error if report didn't exist in DynamoDB
            // this.props.showErrorAlert(errorMessage(err))
        }).finally(() => {
            this.setState({
                loading: false
            })
        })
    }

    componentDidUpdate(prevProps: Readonly<SangerQCReportTableProps>, prevState: Readonly<SangerQCReportCSVTableState>, snapshot?: any) {
        logger.debug("componentDidUpdate")
        if (this.props.reportMetadata.uuid !== prevProps.reportMetadata.uuid
            || this.props.refreshToken !== prevProps.refreshToken) {
            this.getReportResult()
        }
    }

    createTextFilterComponent(placeholder: string): (props: {column: any}) => JSX.Element {
        return ({column}) => (
            <div>
                <input
                    type="text"
                    value={column.getFilterValue() || ''}
                    onChange={e => column.setFilterValue(e.target.value)}
                    placeholder={placeholder}
                    className={`form-control form-control-sm table-small-text-filter`}
                    style={{ width: '100%' }}
                />
            </div>
        )
    }

    getColumns(): ColumnDef<SangerQCReportCSVTableRow, any>[] {
        return [
            {
                accessorKey: 'clone_id',
                header: 'Clone ID',
                enableColumnFilter: true,
                meta: {
                    filterComponent: this.createTextFilterComponent('Search clone ID')
                },
            },
            {
                accessorKey: 'finalLabel',
                header: 'Final label',
                enableColumnFilter: true,
                meta: {
                    filterComponent: this.createTextFilterComponent('Search label')
                },
            },
            {
                accessorKey: 'sgA',
                header: 'sgA',
                enableColumnFilter: false,
            },
            {
                accessorKey: 'sgB',
                header: 'sgB',
                enableColumnFilter: false,
            },
            {
                accessorKey: 'clone_construct',
                header: 'Clone construct',
                enableColumnFilter: false,
            },
            {
                accessorKey: 'sgA_id',
                header: 'sgA ID',
                enableColumnFilter: false,
            },
            {
                accessorKey: 'sgB_id',
                header: 'sgB ID',
                enableColumnFilter: false,
            },
            {
                accessorKey: 'sgA_length',
                header: 'sgA length',
                enableColumnFilter: false,
            },
            {
                accessorKey: 'sgB_length',
                header: 'sgB length',
                enableColumnFilter: false,
            },
            {
                accessorKey: 'label',
                header: 'Sub-label',
                enableColumnFilter: false,
                meta: { hidden: true },
            },
            {
                accessorKey: 'clone',
                header: 'clone',
                enableColumnFilter: false,
                meta: { hidden: true },
            },
            {
                accessorKey: 'hU6',
                header: 'hU6',
                enableColumnFilter: false,
                meta: { hidden: true },
            },
            {
                accessorKey: 'scf1',
                header: 'scf1',
                enableColumnFilter: false,
                meta: { hidden: true },
            },
            {
                accessorKey: 'mU6',
                header: 'mU6',
                enableColumnFilter: false,
                meta: { hidden: true },
            },
            {
                accessorKey: 'scf4',
                header: 'scf4',
                enableColumnFilter: false,
                meta: { hidden: true },
            },
            {
                accessorKey: 'spacer',
                header: 'spacer',
                enableColumnFilter: false,
                meta: { hidden: true },
            },
        ]
    }

    render() {
        if (this.state.loading) {
            return (
                <>
                    <Spinner
                        animation="border"
                        size="sm"
                        variant="primary"
                    >
                    </Spinner>
                    <span className="text-primary m-2 fw-bold">Loading CSV table ...</span>
                </>
            )
        }

        if (this.props.reportMetadata.status.toLowerCase() !== "completed") {
            return (<></>)
        }

        return (
            <Row>
                <Col lg={12}>
                    <TanStackSangerQCReportTable
                        data={this.state.rows}
                        columns={this.getColumns()}
                    />
                </Col>
            </Row>
        );
    }
}